var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form",
    { attrs: { id: "conversion_submit" }, on: { submit: _vm.onSubmit } },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-sm-12" }, [
          _c("label", [_vm._v("Оффер")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-sm-11" },
          [
            _c(
              "b-form-group",
              [
                _c(
                  "v-select",
                  {
                    attrs: {
                      options: _vm.selectOffers,
                      filter: _vm.filterOffers,
                      required: "",
                      label: "title",
                      placeholder: "Оффер"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "option",
                        fn: function(option) {
                          return [
                            _c("span", [
                              _vm._v(
                                "(" +
                                  _vm._s(option.id) +
                                  ") " +
                                  _vm._s(option.title)
                              )
                            ])
                          ]
                        }
                      }
                    ]),
                    model: {
                      value: _vm.selectedOffer,
                      callback: function($$v) {
                        _vm.selectedOffer = $$v
                      },
                      expression: "selectedOffer"
                    }
                  },
                  [
                    _c(
                      "span",
                      { attrs: { slot: "no-options" }, slot: "no-options" },
                      [_vm._v("Совпадений не найдено.")]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.submitted && !_vm.selectedOffer
                  ? _c("span", { staticClass: "alert-danger" }, [
                      _vm._v("Выберите оффер.")
                    ])
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-sm-12" },
          [
            _c(
              "b-form-group",
              { attrs: { label: "Дата загрузки", "label-for": "title" } },
              [
                _c("datepicker", {
                  staticClass: "date",
                  attrs: {
                    "input-class": "form-control",
                    language: _vm.ru,
                    placeholder: ""
                  },
                  model: {
                    value: _vm.conversion.item.loading_date,
                    callback: function($$v) {
                      _vm.$set(_vm.conversion.item, "loading_date", $$v)
                    },
                    expression: "conversion.item.loading_date"
                  }
                }),
                _vm._v(" "),
                _vm.submitted && !_vm.conversion.item.loading_date
                  ? _c("span", { staticClass: "alert-danger" }, [
                      _vm._v("Заполните дату.")
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              { attrs: { label: "Название платформы", "label-for": "title" } },
              [
                _c("b-form-input", {
                  attrs: { id: "title", type: "text" },
                  model: {
                    value: _vm.conversion.item.platform_name,
                    callback: function($$v) {
                      _vm.$set(_vm.conversion.item, "platform_name", $$v)
                    },
                    expression: "conversion.item.platform_name"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              { attrs: { label: "Байер" } },
              [
                _c(
                  "v-select",
                  {
                    attrs: {
                      label: "name",
                      options: _vm.users,
                      required: "",
                      placeholder: "Медиабайер"
                    },
                    model: {
                      value: _vm.selectedUser,
                      callback: function($$v) {
                        _vm.selectedUser = $$v
                      },
                      expression: "selectedUser"
                    }
                  },
                  [
                    _c(
                      "span",
                      { attrs: { slot: "no-options" }, slot: "no-options" },
                      [_vm._v("Совпадений не найдено.")]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.submitted && !_vm.selectedUser
                  ? _c("span", { staticClass: "alert-danger" }, [
                      _vm._v("Выберите байера.")
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              { attrs: { label: "Группа источника" } },
              [
                _c("b-form-input", {
                  attrs: { id: "title", type: "text" },
                  model: {
                    value: _vm.sourceGroupName,
                    callback: function($$v) {
                      _vm.sourceGroupName = $$v
                    },
                    expression: "sourceGroupName"
                  }
                }),
                _vm._v(" "),
                _vm.submitted && !_vm.sourceGroupName
                  ? _c("span", { staticClass: "alert-danger" }, [
                      _vm._v("Заполните группу источника.")
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                attrs: {
                  label: "Количество конверсий",
                  "label-for": "conversions_amount"
                }
              },
              [
                _c("b-form-input", {
                  attrs: { id: "conversions_amount", type: "number" },
                  model: {
                    value: _vm.conversion.item.conversions_amount,
                    callback: function($$v) {
                      _vm.$set(_vm.conversion.item, "conversions_amount", $$v)
                    },
                    expression: "conversion.item.conversions_amount"
                  }
                }),
                _vm._v(" "),
                _vm.submitted && !_vm.conversion.item.conversions_amount
                  ? _c("span", { staticClass: "alert-danger" }, [
                      _vm._v("Заполните количество конверсий.")
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              { attrs: { label: "Adkey рейт", "label-for": "adkey_rate" } },
              [
                _c("b-form-input", {
                  attrs: { id: "adkey_rate", step: "0.01", type: "number" },
                  model: {
                    value: _vm.conversion.item.adkey_rate,
                    callback: function($$v) {
                      _vm.$set(_vm.conversion.item, "adkey_rate", $$v)
                    },
                    expression: "conversion.item.adkey_rate"
                  }
                }),
                _vm._v(" "),
                _vm.submitted && !_vm.conversion.item.adkey_rate
                  ? _c("span", { staticClass: "alert-danger" }, [
                      _vm._v("Заполните рейт.")
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              { attrs: { label: "Валюта" } },
              [
                _c(
                  "v-select",
                  {
                    attrs: {
                      options: _vm.currency,
                      searchable: false,
                      required: ""
                    },
                    model: {
                      value: _vm.conversion.item.currency,
                      callback: function($$v) {
                        _vm.$set(_vm.conversion.item, "currency", $$v)
                      },
                      expression: "conversion.item.currency"
                    }
                  },
                  [
                    _c(
                      "span",
                      { attrs: { slot: "no-options" }, slot: "no-options" },
                      [_vm._v("Совпадений не найдено.")]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.submitted && !_vm.conversion.item.currency
                  ? _c("span", { staticClass: "alert-danger" }, [
                      _vm._v("Добавьте валюту.")
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "float-right",
                attrs: { type: "submit", variant: "primary" }
              },
              [_vm._v("Сохранить и выйти\n            ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-errors" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01c99dae", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01c99dae","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/front/modals/EditConversionModal.vue
// module id = 1064
// module chunks = 0